import { defineComponent as _defineComponent } from 'vue'
import WizardStep from '@/components/wizard/WizardStep.vue';
import CustomersSelect from '@/components/inputs/CustomersSelect.vue';
import { User } from '@/models/user';
import { useI18n } from '@/composables/i18n';
import { required, withLocalizedValidators } from '@/utils/validation';
import useVuelidate from '@vuelidate/core';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'CustomerMembershipWizardStep',
  props: {
    value: null,
    hidden: { type: Boolean, default: false }
  },
  emits: ["input", "leave"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: User): void;
  (e: 'leave', toPreviousPage: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: User, hidden: boolean };





const { t } = useI18n();

const validations = {
  customerId: withLocalizedValidators('inputs.customers_select.label', {
    required,
  }),
};
const v$ = useVuelidate(validations, props.value);

function onInput() {
  emit('input', props.value);
}

return { __sfc: true,props, emit, t, validations, v$, onInput, WizardStep, CustomersSelect }
}

})